import { RootDispatch } from "redux/rootReducer";
import { load, loadSuccess, loadFail } from "./statementsActions";
import * as request from "utility/request";
import { PortfolioStatements } from "types/Statements";

const apiUrl = process.env.REACT_APP_API_URL;

export const loadStatements = (
  reportControlId: string,
  startDate: string,
  endDate: string
) => {
  return async (dispatch: RootDispatch) => {
    dispatch(load());

    try {
      const res = await request.getResponseJson<PortfolioStatements[]>(
        `${apiUrl}/api/statements?reportControlId=${reportControlId}&startDate=${startDate}&endDate=${endDate}`
      );

      dispatch(loadSuccess(res));
    } catch (error) {
      return request.handleFetchError(dispatch, error, loadFail(error));
    }
  };
};
